import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

const MyPreview = ({ stream }) => {
  const videoRef = useRef(null)

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream
    }
  }, [stream])

  return <video ref={videoRef} className="vc-my-video" autoPlay playsInline muted />
}

MyPreview.propTypes = {
  stream: PropTypes.any,
}

export default MyPreview
